import { createSlice } from '@reduxjs/toolkit';
import { Vector3Tuple } from 'three';

import { CONSTANTS } from '@/config/constants';

import type { BBoxDescription } from '../../types/bboxes';
import { exitEditor } from '../project/project.actions';

import { load3DModel } from './bboxes.thunks';

export type BboxesSliceState = {
  view: {
    offset: Vector3Tuple;
    scale: number;
  };
  // absolute bboxes for each mesh
  mesh: {
    $root?: BBoxDescription;
    [stlFileName: string]: BBoxDescription | undefined;
  };
  // absolute bboxes for each geometryclass group
  geometryClasses: {
    [geometryClassName: string]: BBoxDescription | undefined;
  };
};

const initialState: BboxesSliceState = {
  view: {
    offset: [0, 0, 0],
    scale: CONSTANTS.scene.scaleFactor,
  },
  mesh: {},
  geometryClasses: {},
};

export const bboxesSlice = createSlice({
  name: 'bboxes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(load3DModel.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      const { baseName, bbox, view, type } = action.payload;

      if (type === 'mesh') {
        state.mesh[baseName] = bbox;
        state.view = {
          ...state.view,
          ...view,
        };
      } else {
        state.geometryClasses[baseName] = bbox;
      }
    });
    builder.addCase(exitEditor, () => {
      return initialState;
    });
  },
});

export const bboxesReducer = bboxesSlice.reducer;
